import { Button } from "primereact/button";
import { JVInput } from "../../../shared/JVInput";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Fetch } from "../../../shared/Fetch";
import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { JVCheckbox } from "../../../shared/JVCheckbox";

interface IProps {
    open: boolean,
    reload2: boolean,
    setReload2: (reload2: boolean) => void,
    hideDialog: () => void,
    toast: any,
}

export interface IMassMailServerSettingForm {
    server_Name: string,
    server_Email: string,
    server_Password: string,
    server_Port: number,
    server_Max_Limit: number,
    server_Limit_Used?: number,
    server_Status: boolean,
}

const schema = yup.object({
    server_Name: yup.string().required("Server Name required"),
    server_Email:yup.string()   .email("Enter valid email address").required("Server Email required"),
    server_Password: yup.string().required("Server Password required"),
    server_Port: yup.number().typeError("Server Port should be number").min(0).required("Server Port required"),
    server_Max_Limit: yup.number().typeError("Server Max Limit should be number").min(0).required("Server Max Limit required"),
    server_Status: yup.boolean().typeError("Server Status should be number").required("Server Status required"),
});

export const AddServer = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset, } = useForm<IMassMailServerSettingForm>({
        resolver: yupResolver(schema),
        defaultValues: {
            server_Name: "",
            server_Email:"",
            server_Password: "",
            server_Port: 0,
            server_Max_Limit: 0,
            server_Status: true,
        },
        shouldFocusError: false,
    });

    const saveToDB = async (body: IMassMailServerSettingForm) => {
        const method = "POST";
        const message = "Added Successfully";
        setLoading(true);

        body.server_Limit_Used = 0;

        const resp = await Fetch("MassMail/addMassMailServerSetting", method, body, null, null);
        if (resp) {
            props.toast.current.show({ severity: "success", detail: message, life: 3000, });
            props.setReload2(!props.reload2);
            setLoading(false);
            reset({
                server_Name: "",
                server_Email:"",
                server_Password: "",
                server_Port: 0,
                server_Max_Limit: 0,
                server_Status: true,
            });
            props.hideDialog();
        } else setLoading(false);
    };

    const onsubmit = (data: IMassMailServerSettingForm) => {
        saveToDB(data);
    };

    const onHide = () => {
        reset({
            server_Name: "",
            server_Email:"",
            server_Password: "",
            server_Port: 0,
            server_Max_Limit: 0,
            server_Status: true,
        });
        props.hideDialog();
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Mass Mail Server Setting" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onsubmit)}>
                <div className="p-fluid formgrid grid">
                    <JVInput required column={4} label="Server Name" control={control} name="server_Name" error={errors.server_Name?.message} />
                     <JVInput required column={4} label="Server Email" control={control} name="server_Email" error={errors.server_Email?.message} />
                    <JVInput required column={4} label="Server Password" control={control} name="server_Password" error={errors.server_Password?.message} />
                    <JVInput required column={4} label="Server Port" control={control} name="server_Port" error={errors.server_Port?.message} />
                    <JVInput required column={4} label="Server Per Day Max Limit" control={control} name="server_Max_Limit" error={errors.server_Max_Limit?.message} />
                    <JVCheckbox required control={control} name="server_Status" label="Server Status" error={errors.server_Status?.message} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} disabled={loading} style={{ width: "100px" }} label="SAVE" type="submit" ></Button>
                    <Button style={{ width: "100px" }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		" ></Button>
                </div>
            </form>
        </Dialog>
    );
}